import { useEffect, PropsWithChildren, useState } from 'react';
import { accessTokenKey, refreshExpiresInKey, refreshTokenKey } from '../../helpers/local-storage';
import { useNavigate } from 'react-router-dom';
import { concatPath } from '../../helpers/path';
import { RootPath, AuthPath, ManagerPath } from '../../routes/manager/manager-enums';
import { useAuthStore } from '../../store/use-auth-store';

const lifeTime = 1000 * 60 * 3;

export const RouteGuard = (props: PropsWithChildren) => {
  const navigate = useNavigate();
  const { refresh } = useAuthStore();

  const [isHasAuth, setIsHasAuth] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem(accessTokenKey);
    const refreshToken = localStorage.getItem(refreshTokenKey);
    const expiresIn = localStorage.getItem(refreshExpiresInKey);

    const expiresAt = expiresIn ? new Date(Number(expiresIn) * 1000) : null;
    const isExpiringIn3Minutes = expiresAt && expiresAt.getTime() - Date.now() < lifeTime;

    const redir = concatPath([RootPath.Manager, ManagerPath.Auth, AuthPath.Login]);

    const isBadTokens = !accessToken && !refreshToken;
    const isRefreshRequire = refreshToken && (!accessToken || !!isExpiringIn3Minutes);

    if (isBadTokens) {
      navigate(redir);
      return;
    }
    if (isRefreshRequire) {
      refresh()
        .catch(() => navigate(redir))
        .then(() => setIsHasAuth(true));
      return;
    }
    setIsHasAuth(true);
  }, [navigate, refresh]);

  if (!isHasAuth) return null;

  return props.children;
};
